import { createGetRequest } from '_helpers';

export async function getDashboard() {
    return createGetRequest("dashboard_getData")
        .then(res => res.data)
        .then(({ success, data, errorMsg, redirect = false }) => {
            return { response: success, data, errorMsg, redirect };
        })
}